import React, { useEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import { ScrollView, TouchableOpacity } from 'react-native-gesture-handler';
import { useDispatch, useSelector } from 'react-redux';
import { getExpenseCategories, setExpenseValue } from '../../../store/actions/expense';
import { selectExpenseCategories } from '../../../store/selectors/expense.selector';
import { Color, CommonProperties, CommonStyles } from '../../../styles';
import BaseText from '../../BaseText';
import { CheckboxInner } from '../../Checkbox';
import WrapBottomColor from '../../containers/WrapBottomColor';
import RowView from '../../RowView';
import { DynamoDBFieldNames } from '../../../constants/ExpenseCategories';

const CategoryListElement = (props) => {
  const dispatch = useDispatch();
  const { categoryGroup, subCategory, isGroup = false, navigation, route } = props;
  const selectedSubCategory = route?.params?.subCategory;
  const { actionType, subTab } = route?.params || {};
  return (
    <TouchableOpacity
      onPress={() => {
        dispatch(
          setExpenseValue({
            actionType,
            subTab,
            key: DynamoDBFieldNames.SELECTED_SUBCATEGORY,
            value: subCategory,
          })
        );
        navigation.goBack();
      }}
      disabled={isGroup}
    >
      <RowView style={styles.item}>
        {isGroup ? (
          <BaseText style={styles.categoryGroupLabel}>{categoryGroup.GroupName}</BaseText>
        ) : (
          <>
            <BaseText style={styles.categoryLabel}>
              {'\t'}
              {subCategory.Name}
            </BaseText>
            {selectedSubCategory?.SubCategoryId === subCategory.SubCategoryId && (
              <CheckboxInner selected={true} />
            )}
          </>
        )}
      </RowView>
    </TouchableOpacity>
  );
};

const CategorySelectorModal = ({ route, navigation }) => {
  const expenseCategories = useSelector(selectExpenseCategories);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!expenseCategories) {
      dispatch(getExpenseCategories());
    }
  }, [dispatch, expenseCategories]);

  return (
    <WrapBottomColor>
      <ScrollView style={styles.container}>
        {expenseCategories
          ? expenseCategories.map((category) => {
              const { CategoryId, SubCategories } = category;
              return (
                <View key={`CategoryId-${CategoryId}`}>
                  <CategoryListElement categoryGroup={category} isGroup={true} />
                  {SubCategories.map((subCategory) => (
                    <CategoryListElement
                      key={subCategory.SubCategoryId}
                      subCategory={subCategory}
                      navigation={navigation}
                      route={route}
                    />
                  ))}
                </View>
              );
            })
          : null}
      </ScrollView>
    </WrapBottomColor>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
  },
  item: {
    ...CommonProperties.px3,
    ...CommonProperties.py4,
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomWidth: 0.5,
    borderBottomColor: Color.text.low,
  },
  categoryGroupLabel: {
    ...CommonStyles.h3,
    fontWeight: '600',
  },
  categoryLabel: {
    ...CommonStyles.h3,
    color: Color.primary,
  },
});

export default CategorySelectorModal;
